import { useInfiniteQuery, useQuery } from 'react-query'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

const fetchClientContacts = async (id: number, filters: FiltersDomain) => {
  const query = getQueryStrinfied(getValidFilters(filters))

  const { data } = await api.get(`/clients/${id}/contacts?${query}`)

  const contacts = data.data.map((contact: any) => ({
    id: contact.id,
    name: contact.name,
    email: contact.email,
    phone: contact.phone,
  }))

  return {
    ...data,
    data: contacts,
  }
}

export const useClientContactsQuery = (
  clientId: number,
  filters: FiltersDomain
) => {
  return useQuery(
    ['client-contacts', clientId, filters],
    () => fetchClientContacts(clientId, filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true }
  )
}

export const useInfiniteClientContactsQuery = (
  clientId: number,
  filters: FiltersDomain
) => {
  return useInfiniteQuery(
    ['client-contacts', clientId, filters],
    ({ pageParam = 1 }) =>
      fetchClientContacts(clientId, { ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta?.hasNextPage ? meta?.page + 1 : undefined
      },
    }
  )
}
